import { Component } from '@angular/core';

@Component({
  selector: 'app-unregister-sw',
  templateUrl: './unregister-sw.component.html',
  styleUrls: ['./unregister-sw.component.scss']
})
export class UnregisterSwComponent {


  async removeServiceWorkerAndCaches(): Promise<void> {
    if ('serviceWorker' in navigator) {
      try {
        // Força a atualização do SW (se houver um novo)
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          registration.update();
        }

        // Desregistra o service worker
        for (const registration of registrations) {
          const success = await registration.unregister();
          if (success) {
            console.log('Service worker unregistered successfully');
          }
        }

        // Limpa os caches
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }
        console.log('All caches deleted successfully');

        // Força o Bypass for network, removendo o controller do SW
        if (navigator.serviceWorker.controller) {
          console.log('Service worker still controlling, applying bypass...');
          navigator.serviceWorker.controller.postMessage({ action: 'skipWaiting' });
        }

      } catch (error) {
        console.error('Error while unregistering service worker or clearing caches:', error);
      }
    }
  }


}
